import { render, staticRenderFns } from "./VerDetalleCuadratura.vue?vue&type=template&id=75b452a0&"
import script from "./VerDetalleCuadratura.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleCuadratura.vue?vue&type=script&lang=ts&"
import style0 from "./VerDetalleCuadratura.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports